import { textReveal, imageReveal } from "./text-reveal";
import { fadeUp, fadeDownWave, fadeLeft, fadeUpLonger } from "./fades";
import { slideFromLeft, slideFromRight, teamMembersPinnedScroll  } from './slides';
import { textLine } from './text-line';
import { postTextReveal } from "./post-text-reveal";
import ScrollTrigger from "gsap/ScrollTrigger";
import { awardsReveal } from "./awards-reveal";
import { heroImageSlider } from "./hero-image-slider";

let resizeRefreshTimer;
let previousViewportWidth = window.innerWidth;

const refreshAnimationsAfterResize = () => {
	const currentViewportWidth = window.innerWidth;

	if (currentViewportWidth === previousViewportWidth) return;

	previousViewportWidth = currentViewportWidth;
	window.clearTimeout(resizeRefreshTimer);

	resizeRefreshTimer = window.setTimeout(() => {
		ScrollTrigger.refresh(true);
	}, 200);
};

export const initAnimations = () => {
	fadeUp();
	postTextReveal();
	teamMembersPinnedScroll();
	textReveal();
	imageReveal();
	fadeDownWave();
	fadeLeft();
	slideFromLeft();
	slideFromRight();

	textLine();
	fadeUpLonger();
	awardsReveal();
	heroImageSlider();

	requestAnimationFrame(() => ScrollTrigger.refresh());
	window.addEventListener("load", () => ScrollTrigger.refresh(), { once: true });
	window.addEventListener("resize", refreshAnimationsAfterResize);
};
